export const NOTIFICATION_EVENTS = "/admin/app/notification-events";
export const NOTIFICATION_TEMPLATES = "/admin/app/notification-templates";
export const NOTIFICATION_EVENT_SETTINGS =
	"admin/notification-events/settings/";
//Dashboard
export const DEFAULT_INFO = "default-info";
export const DEFAULT_ACADEMIC_INFO = "default-academic-info";
export const DEFAULT_DASHBOARD_INFO = "default-dashboard-info";
export const AVAILABLE_COURSE_LIST = "available-course-list";
export const STUDENT_OVERVIEW = "student-overview";
export const SCHOOL_OVERVIEW = "school-overview";
export const INSTRUCTOR_STUDENT_OVERVIEW = "instructor-student-overview";
export const AUDIENCE_OVERVIEW_CHART = "audience-overview-chart";
export const BROWSER_OVERVIEW_CHART = "browser-overview-chart";
export const BUSINESS_OVERVIEW = "business-overview";
export const CONTACT_OVERVIEW = "contact-overview";
export const TEAM_OVERVIEW = "team-overview";
export const DOCTORS_LIST = "doctors-list";
export const UPCOMING_APPOINTMENTS = "upcoming-appointments";
export const DEFAULT_HOSPITAL_INFO = "default-hospital-info";
export const HOSPITAL_ACTIVITIES = "hospital-activities";
export const PATIENT_STATISTICS = "patient-statistics";
export const HRM_BASIC_DATA = "hrm-basic-data";
export const PROJECT_OVERVIEW = "project-overview";
export const YEARLY_HOLIDAY = "yearly-holiday";
export const EMPLOYEE_OVERVIEW = "employee-overview";
export const TASK = "transaction/task";

// Master
export const MASTER_URL = "master";

export const INQUIRY_TYPE = [MASTER_URL, "inquiry-type"].join("/");
export const LEAD_STATUS = [MASTER_URL, "lead-status"].join("/");
export const MARKETING_CHANNEL = [MASTER_URL, "marketing-channel"].join("/");
export const SCHOOL = [MASTER_URL, "school"].join("/");
export const SCHOOL_LEVEL = [MASTER_URL, "school-level"].join("/");
export const MINIMUM_APPS_VALUE = [MASTER_URL, "minimum-apps-value"].join("/");
export const NAMING_SERIES = [MASTER_URL, "naming-series"].join("/");
export const PARTNER = [MASTER_URL, "partner"].join("/");
export const COUNTRY = [MASTER_URL, "country"].join("/");
export const PROVINCE = [MASTER_URL, "province"].join("/");
export const CITY = [MASTER_URL, "city"].join("/");
export const DISTRICT = [MASTER_URL, "district"].join("/");
export const VILLAGE = [MASTER_URL, "village"].join("/");
export const CENTER = [MASTER_URL, "center"].join("/");
export const PRICE_LIST = [MASTER_URL, "price-list"].join("/");
export const LEARNING_INTEREST = [MASTER_URL, "learning-interest"].join("/");
export const TEST_CONTENT = [MASTER_URL, "test-content"].join("/");
export const REASON = [MASTER_URL, "reason"].join("/");
export const TEACHING_TYPE = [MASTER_URL, "teaching-type"].join("/");
export const PRODUCT_CATEGORY = [MASTER_URL, "product-category"].join("/");
export const PRODUCT_TYPE = [MASTER_URL, "product-type"].join("/");
export const CLASS_TYPE = [MASTER_URL, "class-type"].join("/");
export const PRODUCT_LEVEL = [MASTER_URL, "product-level"].join("/");
export const LANGUAGELIST = [MASTER_URL, "language"].join("/");
export const TEMPLATE_COMMENT = [MASTER_URL, "template-comment"].join("/");
export const PRODUCT_STATUS = [MASTER_URL, "product-status"].join("/");
export const PAYMENT_STATUS = [MASTER_URL, "payment-status"].join("/");
export const UOM = [MASTER_URL, "uom"].join("/");
export const APPOINTMENT_TYPE = [MASTER_URL, "appointment-type"].join("/");
export const PRODUCT = [MASTER_URL, "product"].join("/");
export const COURSE = ["transaction", "course"].join("/");
export const NEW_COURSE = ["transaction", "new-course"].join("/");
export const LIST_PACKAGES = ["master", "list-packages"].join("/");
export const COURSE_TYPE = [MASTER_URL, "course-type"].join("/");
export const BANK = [MASTER_URL, "bank"].join("/");
export const BANK_ACCOUNT = [MASTER_URL, "bank-account"].join("/");
export const CLC_CALENDAR = [MASTER_URL, "academic-calendar"].join("/");
export const CLC_CALENDAR_DETAIL = [
	MASTER_URL,
	"academic-calendar-detail",
].join("/");

// Transaction
export const TRANSACTION_URL = "transaction";
export const LEAD = [TRANSACTION_URL, "lead"].join("/");
export const STUDENT = [TRANSACTION_URL, "customer"].join("/");
export const PARENT = [TRANSACTION_URL, "parent"].join("/");
export const PLACEMENT = [TRANSACTION_URL, "placement"].join("/");
export const SCHOOL_HISTORY = [TRANSACTION_URL, "school-history"].join("/");
export const SIBLING_INFORMATION = [TRANSACTION_URL, "customer"].join("/");
export const CUSTOMER_MARKETING_CHANNEL = [
	TRANSACTION_URL,
	"customer-marketing-channel",
].join("/");
export const PLACEMENT_BEHAVIOR = [TRANSACTION_URL, "placement-behavior"].join(
	"/"
);
export const PLACEMENT_SKILL = [TRANSACTION_URL, "placement-skill"].join("/");
export const PLACEMENT_TEST_CONTENT = [
	TRANSACTION_URL,
	"placement-test-content",
].join("/");
export const PLACEMENT_REASON = [TRANSACTION_URL, "placement-reason"].join("/");
export const ASSIGN_SCHEDULE = [TRANSACTION_URL, "assign-schedule"].join("/");
export const SCHEDULE_RECOMMENDATION = [
	TRANSACTION_URL,
	"schedule-recommendation",
].join("/");
export const EVENT_REGISTRATION_DETAIL = [TRANSACTION_URL, "event-detail"].join(
	"/"
);
// export const INVOICE_HISTORY = [TRANSACTION_URL, "invoice"].join("/");
export const PRODUCT_APPROVAL = [TRANSACTION_URL, "product-approval"].join("/");
export const CONTINUE_LIST = [TRANSACTION_URL, "continue-list"].join("/");
export const INVOICE_NEXT = [TRANSACTION_URL, "invoice-next"].join("/");
export const INVOICE_HISTORY = [TRANSACTION_URL, "invoice"].join("/");
export const INVOICE_HISTORY_V2 = [TRANSACTION_URL, "invoice-v2"].join("/");
export const STUDY_INFORMATION = [TRANSACTION_URL, "invoice-item"].join("/");
export const STUDY_INFORMATION_v2 = [TRANSACTION_URL, "profile-student/invoice/study-information"].join("/");
export const INVOICE_FEE = [TRANSACTION_URL, "invoice-fee"].join("/");
export const INVOICE_FEE_V2 = [TRANSACTION_URL, "invoice-fee-v2"].join("/");
export const COURSE_GROUP = [TRANSACTION_URL, "course-group"].join("/");
export const COURSE_SCHEDULE = [TRANSACTION_URL, "course-schedule"].join("/");
export const TEACHER_PAGES_SCHEDULE_VIEW = [TRANSACTION_URL, "schedule"].join("/");
export const COURSE_HISTORY = [TRANSACTION_URL, "course-history"].join("/");
export const PACKAGES_HISTORY = [TRANSACTION_URL, "packages-history"].join("/");
export const VANUMBER = [TRANSACTION_URL, "va-number"].join("/");
export const BOOKING = [TRANSACTION_URL, "appointment"].join("/");
export const VOUCHER_REQUEST = [TRANSACTION_URL, "voucher-request"].join("/");
export const SALES_PAYMENT = [TRANSACTION_URL, "payment-received"].join("/");
export const INVOICE_OVERDUE = [TRANSACTION_URL, "invoice-overdue"].join("/");
export const FINANCEBOOK = [MASTER_URL, "finance-book"].join("/");

// System
export const SYSTEM = "system";
export const GET_MODEL = [SYSTEM, "model"].join("/");
export const GET_APP_MODEL = [SYSTEM, "app-model"].join("/");

//Sample pages
export const REPORTS = "reports";
export const CALENDARS = "calendars";
export const STAGES = "stages";
export const TASKS = "tasks";

//Profile
export const MY_PROFILE = "/my-profile";
export const All_NOTIFICATION = "/all-notifications";
export const LOGOUT = "/admin/log-out";

//app setting view
export const APP_SETTINGS = "/app-setting";
export const GENERAL_SETTINGS = "general-settings";

//storage setting
export const STORAGE_SETTING = "/storage-configuration";

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = "/get-re-captcha-setting";
//Sms settings
export const GET_SMS_SETTINGS_INFO = "get-sms-setting-info";
//Email settings
export const GET_EMAIL_SETTINGS = "/admin/app/settings/delivery-settings";

//DataTable
export const DATATABLE_DATA = "crud";
export const DATATABLE_EXPORT = "export-crud";
export const DATATABLE_SEARCH_SELECT = "/datatable/name";
export const DATATABLE_SERVER_SEARCH_SELECT =
	"/datatable/serverside/selectable-name";

//Custom TAble
export const CUSTOM_TABLE = "admin/app/custom-tables";

//roles and users
export const ROLES = "admin/auth/roles";
export const USERS = "admin/auth/users";
export const USERS_LIST = "user-list";
export const ALL_USERS = "all-users";
export const GET_USERS = "get/users";
export const GET_STATUSES = "admin/app/statuses";
export const INVITE_USER = "/admin/auth/users/invite-user";
export const DETACH_ROLES = "admin/auth/users/detach-roles/";
export const UPDATE_USER_NAME = "/update-user-name/";

//Notification
export const NOTIFICATIONS = "/admin/user/notifications";
export const AUTHENTICATE_USER = "/admin/authenticate-user";
export const LOGIN_USER = "/login-user";

// Language
export const LANGUAGE = "languages";
export const BASIC_SETTINGS = "/get-basic-setting-data";

// Social links
export const CHANGE_SOCIAL_LINKS = "/change-social-link";

//Payment Methods
export const PAYMENT_METHOD = "/payment-method";
export const GET_PAYMENT_METHOD_STATUS = "/payment-method-status";
export const GET_STRIPE_STATUS = "/stripe-status";
export const GET_PAYPAL_STATUS = "/paypal-status";
export const GET_RAZORPAY_STATUS = "/razorpay-status";
export const GET_XENDIT_STATUS = "/xendit-status";
export const GET_RAZORPAY_INFORMATION = "/razor-pay-information";

// Lead Profile tab Log
export const LEAD_PROFILE_LOG = [TRANSACTION_URL, "task"].join("/");

// Student Profile tab Log
export const STUDENT_PROFILE_LOG = [TRANSACTION_URL, "task"].join("/");

// Parent Profile
export const CHILDREN_INFO = [TRANSACTION_URL, "parent"].join("/");

export const ACADEMIC_FIND_GROUP = [TRANSACTION_URL, "academic-find-group"].join("/");
export const STUDENT_GROUPS = [TRANSACTION_URL, "student-group"].join("/");
export const CLASSTIMETABLE = [TRANSACTION_URL, "class-timetable"].join("/");

// Marketing Channel
export const REGISTRATION_EVENT = [TRANSACTION_URL, "event-registrant-detail"].join("/");

// Voucher
export const API_VOUCHER = ['api', "voucher"].join("/");
export const API_VOUCHER_BY_LEAD = ['api', "voucher", "available"].join("/");
export const API_VOUCHER_CATEGORY = ['api', "voucher-category"].join("/");
export const API_ACADEMIC_CALENDAR = ['api', "academic-calendars"].join("/");
export const API_STUDENT = ['api', "students"].join("/");
export const API_LEAD = ['api', "leads"].join("/");
